import {
  Grid,
  Box,
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
import { useState } from "react";
import { ContrattoDetailed } from "../../models/ContrattoModel";
import EditIcon from "@mui/icons-material/Edit";
import { displayFormatted } from "../../utils/date";
import DisplayField from "../shared/DisplayField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContrattoFormComponent from "./ContrattoFormComponent";
import ContractStateHistory from "./ContractStateHistory";
import SectionTitle from "../shared/SectionTitle";
import BackButton from "../shared/BackButton";

interface WithContratto {
  contratto: ContrattoDetailed;
}

const ContrattoDetailComponent: React.FC<WithContratto> = ({ contratto }) => {
  // const { token } = useContext(apiContext)
  // const queryClient = useQueryClient()

  const [mainDataEditFormOpen, setMainDataEditFormOpen] =
    useState<boolean>(false);
  const toggleMainDataEditFormOpen = () =>
    setMainDataEditFormOpen(!mainDataEditFormOpen);

  const state2Color = [
    { id: "Proposto", color: "#2196f3" },
    { id: "Firmato", color: "#4caf50" },
    { id: "Concluso", color: "#388e3c" },
    { id: "Rifiutato", color: "#f44336" },
    { id: "Scaduto", color: "#ff9800" },
  ];

  const colorMap = new Map();
  state2Color.forEach((data) => {
    colorMap.set(data.id, data.color);
  });

  const statoColor = colorMap.get(contratto.statocontratto.nome) || "#000000";

  // TODO: verify if (statoContrattoQuery.isError) return (<Navigate to="/contratto" />)

  return (
    <>
      <Box>
        <BackButton />
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Contratto - Dati Principali" />
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              {/* <DisplayField title="Quantità" text={contratto.quantita + ""} />
              <DisplayField title="Importo" text={contratto.importo + " €"} /> */}
              <DisplayField
                title="Cliente"
                text={
                  contratto.anagraficacliente.personafisica?.cognome +
                  (" " + contratto.anagraficacliente.personafisica?.nome)
                }
              />
              <DisplayField
                title="Stato"
                text={contratto.statocontratto.nome}
                textColor={statoColor}
              />
              <DisplayField
                title="Tipologia"
                text={contratto.tipologiacontratto.nome}
              />
              {/*TODO: verify if I need to print the document type */}
              <DisplayField
                title="Documento Associato"
                text={
                  contratto.customer_document?.document_number !== undefined
                    ? contratto.customer_document?.document_number +
                      (" " + contratto.customer_document?.released_by)
                    : "-"
                }
              />
              <DisplayField
                title="Conto Associato"
                text={contratto.bank_account?.iban || "-"}
              />
              <DisplayField
                title="Data di Scadenza"
                text={displayFormatted(contratto.data_scadenza)}
              />
            </Grid>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <DisplayField
                fill={10}
                title="Note"
                text={contratto.note || "-"}
              />
            </Grid>
          </AccordionDetails>
          <AccordionActions>
            <Button
              variant="contained"
              color="primary"
              startIcon={<EditIcon />}
              onClick={() => {
                setMainDataEditFormOpen(true);
              }}
            >
              Modifica
            </Button>
          </AccordionActions>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SectionTitle title="Contratto - Storico Stati" />
          </AccordionSummary>
          <AccordionDetails>
            <Box display={"flex"} justifyContent={"center"}>
              <ContractStateHistory history={contratto.storicostatocontratto} />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>

      {/* Edit */}
      <ContrattoFormComponent
        initialData={contratto}
        open={mainDataEditFormOpen}
        toggleOpen={toggleMainDataEditFormOpen}
        editEnabled={true}
      />
    </>
  );
};

export default ContrattoDetailComponent;
